






























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGoodsSpecs, TbSettingsPad } from '@/http';
import { NumberKeyboard } from "@/components";
import { Toast, Dialog } from 'vant';
@Component({
    components: {
        NumberKeyboard
    },
})
export default class integralSet extends Vue {

    public $refs: {
    };

    tabList = [
        {
            label: '积分获取',
            value: 1,
        },
        {
            label: '积分抵扣',
            value: 2,
        },
    ];

    active = 1;

    form: any = {};
    isEdit = false;
    isEdit2 = false;

    isLoading = false;
    isLoading2 = false;

    userInfo = {};

    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }

    async mounted() {
        this.init();
    }

    chooseTab(item) {
        this.active = item.value;
        this.init();
    }

    async init() {
        let settingtype = this.active == 1 ? 8 : 9;
        let res = await TbSettingsPad.GetTbSettings({
            settingtype: settingtype
        });
        this.form = res;
    }

    finishNum(val, type) {
        switch (type) {
            case 1:
                this.form.settingContent.consumptionPoints.per = val;
                break;
            case 2:
                this.form.settingContent.rechargePoints.per = val;
                break;
            case 3:
                this.form.settingContent.birthdayPoints.integral = val;
                break;
            case 4:
                this.form.settingContent.per = val;
                break;
            case 5:
                this.form.settingContent.topLimit = val;
                break;

            default:
                break;
        }
    }
    changeRadio(val, type) {
        switch (type) {
            case 1:
                this.form.settingContent.consumptionPoints.isOpen = val;
                break;
            case 2:
                this.form.settingContent.rechargePoints.isOpen = val;
                break;
            case 3:
                this.form.settingContent.birthdayPoints.isOpen = val;
                break;
            case 4:
                this.form.settingContent.isOpen = val;
                break;

            default:
                break;
        }
    }
    cancelFun() {
        this.isEdit = false;
        this.init();
    }
    cancelFun2() {
        this.isEdit2 = false;
        this.init();
    }
    showEdit() {
        if (!this.hasAuth('402')) {
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor: '#0491A7'
            }).then(() => {

            });
            return;
        }
        this.isEdit = !this.isEdit;
    }
    showEdit2() {
        if (!this.hasAuth('402')) {
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor: '#0491A7'
            }).then(() => {

            });
            return;
        }
        this.isEdit2 = true;
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
            val = false;
        }
        if (btnPermissionsStr.some(v => v == auth)) {
            val = true;
        }
        return val;
    }
    async saveEdit() {
        if (this.isLoading) return;
        if (!this.form.settingContent.consumptionPoints.per) {
            Toast('请填写相应信息');
            return;
        }
        if (!this.form.settingContent.rechargePoints.per) {
            Toast('请填写相应信息');
            return;
        }
        if (!this.form.settingContent.birthdayPoints.integral) {
            Toast('请填写相应信息');
            return;
        }
        if (Number(this.form.settingContent.consumptionPoints.per) == 0 || Number(this.form.settingContent.rechargePoints.per) == 0) {
            Toast('金额不能0');
            return;
        }
        if (Number(this.form.settingContent.birthdayPoints.integral) == 0) {
            Toast('积分倍数不能0');
            return;
        }
        this.isLoading = true;

        try {
            let res = await TbSettingsPad.PutTbSettings({
                id: this.form.id,
                settingContent: JSON.stringify(this.form.settingContent)
            })
            Toast('保存成功');
            this.isEdit = false;
            this.isLoading = false;
            await this.init();
        } catch (error) {
            this.isLoading = false;
        }
    }
    async saveEdit2() {
        if (this.isLoading2) return;

        console.log('this.form.settingContent', this.form.settingContent);


        if (!this.form.settingContent.per) {
            Toast('请填写相应信息');
            return;
        }
        if (this.form.settingContent.topLimit === null || this.form.settingContent.topLimit === '') {
            Toast('请填写相应信息');
            console.log('ssscdsadsad', this.form.settingContent.topLimit);

            return;
        }

        this.isLoading2 = true;

        try {
            let res = await TbSettingsPad.PutTbSettings({
                id: this.form.id,
                settingContent: JSON.stringify(this.form.settingContent)
            })
            Toast('保存成功');
            this.isEdit2 = false;
            this.isLoading2 = false;
            await this.init();
        } catch (error) {
            this.isLoading2 = false;
        }
    }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/integralSet.vue